import { Configuration } from './runtime';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

export const apiConfig = new Configuration({
  basePath: API_BASE_URL,
  middleware: [
    {
      pre: async (context) => {
        const token = localStorage.getItem('token');
        if (token) {
          return {
            url: context.url,
            init: {
              ...context.init,
              headers: {
                ...context.init.headers,
                Authorization: `Bearer ${token}`,
              },
            },
          };
        }
        return { url: context.url, init: context.init };
      },
    },
  ],
});
